module.exports = __webpack_public_path__ + "static/img/title-banner1-type1.8d4d40a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/title-banner1-type1.png
// module id = Nx7Y
// module chunks = 1